import { useState, useRef } from "react";
import { Box, CircularProgress } from "@mui/material";
import { InputField } from "../Common/InputField";
import { useDispatch, useSelector } from "react-redux";
import { globalStyle, handleVisibleForEdit, handleDangerVisible } from "../../global/Utils";
import { printingInvoiceReport } from "../../Actions/LedgerReportsActions";

import { upperCaseInput } from "../../global/textCase";
import { SearchableSelect } from "../Common/SearchableSelect";
export const InvoiceLedgerModal = (props) => {
  const dispatch = useDispatch();
  const today = new Date();
  const formRef = useRef(null);
  const maxDate = today.toISOString().split("T")[0];
  const { companiesList, isGettingCompanyList } = useSelector(
    (state) => state?.CompanyListReducer,
  );
  const { isPrintingInvoiceLedgerReport } = useSelector(
    (state) => state?.LedgerReportsReducer,
  );
  const [formData, setFormData] = useState({
    startDate: "",
    endDate: "",
    companyId: "",
  });
  const [errors, setErrors] = useState({});

  /* ---------------- Handle Change ----------------- */
  const handleChange = (e) => {
    const { name, value } = upperCaseInput(e.target);
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };
  /* ------------------ VALIDATION ------------------ */
  const validate = () => {
    const newErrors = {};
    const requiredFields = ["startDate", "endDate", "companyId"];

    requiredFields.forEach((field) => {
      if (!formData[field]?.toString().trim()) {
        newErrors[field] = "This field is required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  /* ------------------ SUBMIT ------------------ */
  const handlePrint = (e, type) => {
    e.preventDefault();
    if (!validate()) {
      setTimeout(() => {
        const firstError = document.querySelector(".border-red-500");
        if (firstError) {
          firstError.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          firstError.focus();
        }
      }, 100);
      return;
    }
    dispatch(
      printingInvoiceReport(
        formData,
        type,
        props?.onClose,
        setFormData,
        handleVisibleForEdit,
        handleDangerVisible,
        {
          startDate: formData?.startDate,
          endDate:formData?.endDate,
          company: companiesList?.find((item) => item?._id === formData?.companyId),
        }
      ),
    );
  };
  if (!props?.isOpen) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-[1500]">
      <div className="bg-white rounded-xl w-full max-w-2xl shadow-xl p-6 relative">
        <button
          onClick={props?.onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-black"
        >
          ✕
        </button>
        {isGettingCompanyList ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "80px",
            }}
          >
            <CircularProgress size={30} />
          </Box>
        ) : (
          <form ref={formRef} className="space-y-6">
            <h2
              className="text-center font-bold text-xl"
              style={{
                fontFamily: globalStyle.fontFamilyHeading,
                color: globalStyle.curveDarkColor,
              }}
            >
              Invoice Ledger Report
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="col-span-1 md:col-span-2">
                <label className="block mb-1 font-medium">
                  Company Name<span className="text-red-500">*</span>
                </label>
                <SearchableSelect
                  name="companyId"
                  value={formData.companyId}
                  onChange={handleChange}
                  disabled={!companiesList || companiesList.length === 0}
                  className={`w-full px-4 py-2 border rounded-md ${
                    errors.companyId ? "border-red-500" : "border-gray-300"
                  }`}
                >
                  {!companiesList || companiesList.length === 0 ? (
                    <option value="">No Companies Available</option>
                  ) : (
                    <>
                      <option value="">Select</option>
                      {companiesList.map((company) => (
                        <option key={company._id} value={company._id}>
                          {company.companyName} / {company?.ntn}
                        </option>
                      ))}
                    </>
                  )}
                </SearchableSelect>

                {errors.companyId && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.companyId}
                  </p>
                )}
              </div>
              <InputField
                label="Start Date"
                name="startDate"
                max={maxDate}
                type="date"
                value={formData.startDate}
                error={errors.startDate}
                onChange={handleChange}
                required
              />
              <InputField
                label="End Date"
                name="endDate"
                max={maxDate}
                min={formData.startDate}
                type="date"
                value={formData.endDate}
                error={errors.endDate}
                onChange={handleChange}
                disabled={!formData.startDate}
                required
              />
            </div>
            <div className="flex justify-center gap-4">
              <button
                type="button"
                disabled={isPrintingInvoiceLedgerReport}
                onClick={(e) => handlePrint(e, "PDF")}
                className="px-6 py-2 rounded-md text-white font-bold disabled:opacity-50 disabled:bg-gray-400"
                style={{ background: globalStyle.buttonColor }}
              >
                {isPrintingInvoiceLedgerReport ? "Please Wait..." : "Print PDF"}
              </button>
              <button
                type="button"
                disabled={isPrintingInvoiceLedgerReport}
                onClick={(e) => handlePrint(e, "EXCEL")}
                className="px-6 py-2 rounded-md text-white font-bold disabled:opacity-50 disabled:bg-gray-400"
                style={{ background: globalStyle.buttonColor }}
              >
                {isPrintingInvoiceLedgerReport
                  ? "Please Wait..."
                  : "Print Excel"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};
